import { syncCost } from '@/api/advertiser'
import moment from 'moment'

export default {
    components: {},
    props: {
        showForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        },
    },
    data() {
        return {
            labelCol: { span: 4 },
            wrapperCol: { span: 18 },
            loading: false,
            rules: {
                day: [{ required: true, message: '请选择投放日期', trigger: 'change' }],
            },
            admins:[],
        }
    },
    computed: {},
    mounted() {
        this.model.day = moment()
    },
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.syncCost()
            })
        },
        syncCost() {
            this.loading = true
            if (moment.isMoment(this.model.day)) {
                this.model.day = moment(this.model.day).format('YYYY-MM-DD');
            } 
            syncCost(this.model).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success('操作成功')
                    this.$emit('success')
                    this.close()
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            this.$refs.form.resetFields()
            this.$emit('update:showForm', false)
        },
        changeDay(type) {
            if (!moment.isMoment(this.model.day)) {
                this.model.day = moment(this.model.day);
            } 
           if (type == 1) {
                this.model.day = this.model.day.subtract(1, 'days')
           } else {
                this.model.day = this.model.day.add(1, 'days')
           }
           
           this.model.day = moment(this.model.day).format('YYYY-MM-DD');
        }
    }
}
